// var url = {
//     localhost: '/api',
//     dev: 'https://dev2mall.unisiot.com',
//     chk: 'https://chk-agentmall.unisiot.com',
//     production: 'https://umall.unisiot.com'
// }
// if (window.location.host.includes('localhost')) {
//     window.baseUrl = url.localhost + '/pc'
//     window.commonUrl = url.localhost
// } else if (window.location.host.includes('dev')) {
//     window.baseUrl = url.dev + '/pc'
//     window.commonUrl = url.dev
// } else if (window.location.host.includes('chk')) {
//     window.baseUrl = url.chk + '/pc'
//     window.commonUrl = url.chk
// } else {
//     window.baseUrl = url.production + '/pc'
//     window.commonUrl = url.production
// }
// window.uploadUrl = window.commonUrl + '/common/upload/sample' // 文件上传

window.commonUrl = 'https://umall.unisiot.com'
window.baseUrl = window.commonUrl + '/pc'
window.uploadUrl = window.commonUrl + '/common/upload/sample' // 文件上传

export default {
    commonUrl: window.commonUrl,
    baseUrl: window.baseUrl,
    uploadUrl: window.uploadUrl
}



// WEBPACK FOOTER //
// ./src/config.js